export default `
<div class="modal fade modal-lg" id="bootstrapModal" tabindex="-1" aria-labelledby="bootstrapModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="bootstrapModalLabel">{{modalTitle}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        {{{modalBody}}}
      </div>
      <!--
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{closeButtonText}}</button>
        <button type="button" class="btn btn-primary">{{saveButtonText}}</button>
      </div>
      -->
    </div>
  </div>
</div>`;
